var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "meteor-icon-kit__solid-bell",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.874 21C15.4299 22.7252 13.8638 24 12 24C10.1362 24 8.57006 22.7252 8.12602 21H2.5C1.11929 21 0 19.8807 0 18.5C0 17.2334 0.618425 16.0466 1.65654 15.321L2.4271 14.7824C3.4128 14.0934 4 12.9666 4 11.764V7.60205C4 3.40355 7.40355 0 11.6021 0H12.4608C16.6246 0 20 3.37541 20 7.53918V11.6017C20 12.839 20.5907 14.0019 21.5898 14.7317L22.3785 15.3077C23.3976 16.052 24 17.2381 24 18.5C24 19.8807 22.8807 21 21.5 21H15.874ZM13.7324 21H10.2676C10.6134 21.5978 11.2597 22 12 22C12.7403 22 13.3866 21.5978 13.7324 21Z",
    fill: "#fcfcfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSvgrepoCom);
export default __webpack_public_path__ + "static/media/bell-svgrepo-com.6f0101ed128197b6d089082da933240d.svg";
export { ForwardRef as ReactComponent };